/**
 * @generated SignedSource<<b1a186d28ddb6caa7b8886eb2601b8af>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ExportInvoiceButton_company$data = {
  readonly newXeroEnabled: boolean | null;
  readonly quickbooksEnabled: boolean | null;
  readonly economicEnabled: boolean | null;
  readonly quickbooksRealmId: string | null;
  readonly sageIntacctConnectionEnabled: boolean | null;
  readonly clients: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly name: string;
        readonly xeroContactId: string | null;
        readonly xeroDefaultTaxRate?: {
          readonly name: string | null;
          readonly effectiveRate: number | null;
          readonly organisation: string | null;
        } | null;
        readonly economicCustomerId: string | null;
        readonly quickbooksCustomerId: string | null;
        readonly quickbooksRealmId: string | null;
        readonly sageIntacctCustomerId: string | null;
      } | null;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "ExportInvoiceButton_company";
};
export type ExportInvoiceButton_company$key = {
  readonly " $data"?: ExportInvoiceButton_company$data;
  readonly " $fragmentSpreads": FragmentRefs<"ExportInvoiceButton_company">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "quickbooksRealmId",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "xeroInvoicingImprovements"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "ExportInvoiceButton_company",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "newXeroEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "quickbooksEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "economicEnabled",
      "storageKey": null
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sageIntacctConnectionEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ClientTypeConnection",
      "kind": "LinkedField",
      "name": "clients",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ClientTypeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Client",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "xeroContactId",
                  "storageKey": null
                },
                {
                  "condition": "xeroInvoicingImprovements",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ClientDefaultTaxRate",
                      "kind": "LinkedField",
                      "name": "xeroDefaultTaxRate",
                      "plural": false,
                      "selections": [
                        (v1/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "effectiveRate",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "organisation",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ]
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "economicCustomerId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "quickbooksCustomerId",
                  "storageKey": null
                },
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "sageIntacctCustomerId",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Company",
  "abstractKey": null
};
})();

(node as any).hash = "923dac09149ec789e8541cd0a7460a4f";

export default node;
